import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {
  AppkitDropDownEventType,
  CreateDisclosureSharedService,
  DropDownType,
  EntityNameChange
} from '../../create-disclosure-shared.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {
  stripAmountFormatting,
  stripAmountFields,
  SEC926_ARRAY_AMOUNT_KEYS,
  SEC926_SCALAR_AMOUNT_KEYS
} from '../../dst-amount.util';
import {toSaveString, safeEntityField, safeEntityId} from '../../dst-save.util';

import { safeJsonInput } from '../../../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'dst-template-sec926-id214',
    templateUrl: './template-sec926-id214.component.html',
    styleUrls: ['../template-shared.scss', './template-sec926-id214.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec926Id214Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  selectedOptionID!: Event;
  startLoader: boolean = false;
  statementId: string = '';
  dcnId!: number;
  dcnName: string = '';
  dcnIDNum: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;

  beginDate!: Date;
  endDate!: Date;
  defaultDate!: Date;

  desc: string = '';
  date!: Date | string;

  showTransferee: boolean = false;
  showTransfereeManual: boolean = false;
  showControllingShareHolders: boolean | null = null;
  showDomesticCorporation: boolean = false;

  hideSections: boolean = false;
  isForeignCorporation: boolean = false;
  isForeignCorporation2: boolean = false;
  isForeignCorporation3: boolean = false;

  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  partnership!: DSTEntityDetails | null;

  showDREMsg: boolean = false;
  DREMsg: string = '';

  tabs: S926PropertyTab[] = [
    {
      label: '1',
      labelIndex: 1,
      propertyType: '',
      date: '',
      description: '',
      fairMarketVal: 0,
      cost: 0,
      gain: 0,
      useful: 0,
      armLength: 0,
      income: 0,
      propertyTypeOptions: [
        {
          value: 'cash',
          label: 'Cash',
          index: 0,
        },
        {
          value: 'stockssecurities',
          label: 'Stocks and securities',
          index: 1,
        },
        {
          value: 'inventory',
          label: 'Inventory',
          index: 2,
        },
        {
          value: 'otherProp926',
          label: 'Other Property (not listed under another category)',
          index: 3,
        },
        {
          value: 'lossProp',
          label: 'Property with built-in loss',
          index: 4,
        },
        {
          value: 'propdescribed367d4',
          label: 'Property described in sec.367(d)(4)',
          index: 5,
        }
      ],
      dateObj: null,
      selectedPropertyTypeItem: null
    }
  ];
  selected = new UntypedFormControl(0);
  EINMissingReason: any[] = [
    { value: '', label: '** Please select the missing reason **' },
    {
      id: 1,
      value: 'APPLD FOR',
      label: 'APPLD FOR'
    },
    {
      id: 2,
      value: 'FOREIGNUS',
      label: 'FOREIGNUS'
    },
  ];
  EINMissingReason1: any[] = [
    { value: '', label: '** Please select the missing reason **' },
    {
      id: 1,
      value: 'APPLD FOR',
      label: 'APPLD FOR'
    },
    {
      id: 2,
      value: 'FOREIGNUS',
      label: 'FOREIGNUS'
    },
  ];
  EINMissingReason2: any[] = [
    { value: '', label: '** Please select the missing reason **' },
    {
      id: 1,
      value: 'APPLD FOR',
      label: 'APPLD FOR'
    },
    {
      id: 2,
      value: 'FOREIGNUS',
      label: 'FOREIGNUS'
    },
  ];
  EINMissingReason3: any[] = [
    { value: '', label: '** Please select the missing reason **' },
    {
      id: 1,
      value: 'APPLD FOR',
      label: 'APPLD FOR'
    },
    {
      id: 2,
      value: 'FOREIGNUS',
      label: 'FOREIGNUS'
    },
  ];
  EINMissingReason4: any[] = [
    { value: '', label: '** Please select the missing reason **' },
    {
      id: 1,
      value: 'APPLD FOR',
      label: 'APPLD FOR'
    },
    {
      id: 2,
      value: 'FOREIGNUS',
      label: 'FOREIGNUS'
    },
  ];
  transferorEinMissingReason: string = '';
  selectedMissingReason1: number = -1;
  selectedMissingReason2: string = '';
  selectedMissingReason3: number = -1;
  selectedMissingReasonPart: number = -1;
  selectedTransferorEINItem: any = null;
  selectedEINMissing1Item: any = null;
  selectedEINMissing2Item: any = null;
  selectedEINMissing3Item: any = null;
  selectedEINMissing4Item: any = null;
  selectedCountry1Item: any = null;
  selectedCountry2Item: any = null;

  cost: number = 0;
  gain: number = 0;
  useful: number = 0;
  armsLength: number = 0;
  income: number = 0;
  selectedIndex: number = -1;
  fairMarketVal: number = 0;

  controllingShareholder: string = '';
  identifyingNumber: string = '';

  transfereeForeignCorp!: boolean;
  Choice1a!: boolean;
  Choice1b!: boolean;
  EinOrSsn!: string;
  Choice1c!: boolean;
  Choice1d!: boolean;
  Choice2b!: boolean;
  Choice2c!: boolean;
  Choice2d!: boolean;

  IsForeignCorpInGold!: boolean;
  name: string = '';
  id: string = '';
  address1: string = '';
  address2: string = '';
  city: string = '';
  state: string = '';
  country: string = '';
  postal: string = '';
  country2: string = '';
  foreign: string = '';
  transferredLoss: string = '';
  regulationAmt: string = '';
  transaction: string = '';
  gainOrLoss: string = '';
  suppInfo: string = '';
  before: string = '';
  after: string = '';
  IsTransfereeForeignCorpCtrld!: boolean;

  cashonlytransfered: boolean = false;
  transferunder367a: boolean = false;
  foreignassets!: boolean;
  domesticcorptransfer!: boolean;
  transfereeshareholder!: boolean;
  intangiblepropsec936h: boolean = false;
  intangibleusefullife: boolean = false;
  indefiniteusefullife: boolean = false;
  intangiblepropinclusion: boolean = false;
  anticipatedtransfer: boolean = false;

  gainunder904f3: boolean = false;
  gainunder904f5: boolean = false;
  recapunder1503d: boolean = false;
  exchangeunder987: boolean = false;
  forcorptransferee: boolean = false;
  domesticcorpsec367e!: boolean;
  propusedinustrade!: boolean;
  sec355stock!: boolean;

  countryDropdown1: any[] = [];
  countryDropdown2: any[] = [];
  stateValue: string = '';
  StateOptions: any[] = [];

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private trackerTabsService: TrackerTabsService,
              private headerService: TemplateHeaderService,
              private cdref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.editMode = false;
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    this.defaultDate = new Date(this.sharedService.getActiveFormState()?.taxYear || 2021, 0, 1);

    this.sharedService.getStateDropdown().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: DropDownType[]) => {
      data.forEach(element => {
        this.StateOptions.push({
          value: element.id,
          label: element.text
        });
      });
    }, () => {

    }, () => {
    });

    this.sharedService.getCountryDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.countryDropdown1.push({
            value: element.id,
            label: element.text
          });
          this.countryDropdown2.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {
        if (this.attMap['Country']) {
          const updatedData = this.updateDropdownList(this.countryDropdown1, this.attMap['Country'][0], true);
          this.countryDropdown1 = updatedData.dropdownData;
          this.country = updatedData.index + '';
          this.selectedCountry1Item = this.countryDropdown1.find((i: any) => i.selected) || null;
        }
        if (this.attMap['TransfereeCountry']) {
          const updatedData = this.updateDropdownList(this.countryDropdown2, this.attMap['TransfereeCountry'][0], true);
          this.countryDropdown2 = updatedData.dropdownData;
          this.country2 = updatedData.index + '';
          this.selectedCountry2Item = this.countryDropdown2.find((i: any) => i.selected) || null;
        }
      });
    this.statementId = this.sharedService.getFormData()?.statementid.toString() || '';
  }

  ngAfterViewInit(): void {
    if (this.sharedService.getFormStateByFormId(214)?.isChild) {
      this.sharedService.getLoadStatementData(214).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: StmtData) => {
        this.sharedService.setFormData(data, 214);
        this.loadStmtData();
      }, (eMsg: string) => {
        console.log(eMsg);
        this.dstSharedService.showAlert('error', eMsg);
      });
    } else {
      this.loadStmtData();
    }
  }

  private loadStmtData(): void {
    const data: StmtData | undefined = this.sharedService.getFormData(214);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      this.editMode = true;
      data.children?.forEach((stmt: StmtAttrData) => {
        if (this.attMap[stmt.attributeName] == undefined) {
          this.attMap[stmt.attributeName] = [];
        }
        if (stmt.attributeValue != null) {
          this.attMap[stmt.attributeName].push(stmt.attributeValue);
        }
      });
      if (this.attMap['transfereeForeignCorp'] && this.attMap['transfereeForeignCorp'][0]) {
        this.transfereeForeignCorp = this.attMap['transfereeForeignCorp'][0] === '1';
      }
      if (this.attMap['Choice1a'] && this.attMap['Choice1a'][0]) {
        this.Choice1a = this.attMap['Choice1a'][0] === 'Yes';
      }
      if (this.attMap['Choice1b'] && this.attMap['Choice1b'][0]) {
        this.Choice1b = this.attMap['Choice1b'][0] === 'Yes';
        this.showControllingShareHolders = !(this.attMap['Choice1b'][0] === 'Yes');
      }
      if (this.attMap['Choice1c'] && this.attMap['Choice1c'][0]) {
        this.Choice1c = this.attMap['Choice1c'][0] === 'Yes';
      }
      if (this.attMap['Choice1d'] && this.attMap['Choice1d'][0]) {
        this.Choice1d = this.attMap['Choice1d'][0] === 'Yes';
      }
      if (this.attMap['EinOrSsn'] && this.attMap['EinOrSsn'][0]) {
        this.EinOrSsn = this.attMap['EinOrSsn'][0];
      }
      if (this.attMap['Choice2b'] && this.attMap['Choice2b'][0]) {
        this.Choice2b = this.attMap['Choice2b'][0] === 'Yes';
      }
      if (this.attMap['Choice2c'] && this.attMap['Choice2c'][0]) {
        this.Choice2c = this.attMap['Choice2c'][0] === 'Yes';
      }
      if (this.attMap['Choice2d'] && this.attMap['Choice2d'][0]) {
        this.Choice2d = this.attMap['Choice2d'][0] === 'Yes';
      }
      if (this.attMap['IsForeignCorpInGold'] && this.attMap['IsForeignCorpInGold'][0]) {
        this.IsForeignCorpInGold = this.attMap['IsForeignCorpInGold'][0] === 'Yes';
        this.IsForeignCorpInGold ? this.checkTransferee({}) : this.checkTransfereeManual({});
      } else if (data.secondaryleid) {
        // if this 926 is auto-generated
        this.IsForeignCorpInGold = true;
        this.checkTransferee({});
      }
      if (this.attMap['IsTransfereeForeignCorpCtrld'] && this.attMap['IsTransfereeForeignCorpCtrld'][0]) {
        this.IsTransfereeForeignCorpCtrld = this.attMap['IsTransfereeForeignCorpCtrld'][0] === 'Yes';
      }
      if (this.attMap['cashonlytransfered'] && this.attMap['cashonlytransfered'][0]) {
        this.cashonlytransfered = this.hideSections = this.attMap['cashonlytransfered'][0] === '1';
      }
      if (this.attMap['transferunder367a'] && this.attMap['transferunder367a'][0]) {
        this.transferunder367a = this.attMap['transferunder367a'][0] === '1';
      }
      if (this.attMap['foreignassets'] && this.attMap['foreignassets'][0]) {
        this.foreignassets = this.isForeignCorporation = this.attMap['foreignassets'][0] === '1';
      }
      if (this.attMap['domesticcorptransfer'] && this.attMap['domesticcorptransfer'][0]) {
        this.domesticcorptransfer = this.isForeignCorporation2 = this.attMap['domesticcorptransfer'][0] === '1';
      }
      if (this.attMap['transfereeshareholder'] && this.attMap['transfereeshareholder'][0]) {
        this.transfereeshareholder = this.isForeignCorporation3 = this.attMap['transfereeshareholder'][0] === '1';
      }
      if (this.attMap['intangiblepropsec936h'] && this.attMap['intangiblepropsec936h'][0]) {
        this.intangiblepropsec936h = this.attMap['intangiblepropsec936h'][0] === '1';
      }
      if (this.attMap['intangibleusefullife'] && this.attMap['intangibleusefullife'][0]) {
        this.intangibleusefullife = this.attMap['intangibleusefullife'][0] === '1';
      }
      if (this.attMap['indefiniteusefullife'] && this.attMap['indefiniteusefullife'][0]) {
        this.indefiniteusefullife = this.attMap['indefiniteusefullife'][0] === '1';
      }
      if (this.attMap['intangiblepropinclusion'] && this.attMap['intangiblepropinclusion'][0]) {
        this.intangiblepropinclusion = this.attMap['intangiblepropinclusion'][0] === '1';
      }
      if (this.attMap['anticipatedtransfer'] && this.attMap['anticipatedtransfer'][0]) {
        this.anticipatedtransfer = this.attMap['anticipatedtransfer'][0] === '1';
      }
      if (this.attMap['gainunder904f3'] && this.attMap['gainunder904f3'][0]) {
        this.gainunder904f3 = this.attMap['gainunder904f3'][0] === '1';
      }
      if (this.attMap['gainunder904f5'] && this.attMap['gainunder904f5'][0]) {
        this.gainunder904f5 = this.attMap['gainunder904f5'][0] === '1';
      }
      if (this.attMap['recapunder1503d'] && this.attMap['recapunder1503d'][0]) {
        this.recapunder1503d = this.attMap['recapunder1503d'][0] === '1';
      }
      if (this.attMap['exchangeunder987'] && this.attMap['exchangeunder987'][0]) {
        this.exchangeunder987 = this.attMap['exchangeunder987'][0] === '1';
      }
      if (this.attMap['forcorptransferee'] && this.attMap['forcorptransferee'][0]) {
        this.forcorptransferee = this.attMap['forcorptransferee'][0] === '1';
      }
      if (this.attMap['domesticcorpsec367e'] && this.attMap['domesticcorpsec367e'][0]) {
        this.domesticcorpsec367e = this.showDomesticCorporation = this.attMap['domesticcorpsec367e'][0] === '1';
      }
      if (this.attMap['propusedinustrade'] && this.attMap['propusedinustrade'][0]) {
        this.propusedinustrade = this.attMap['propusedinustrade'][0] === '1';
      }
      if (this.attMap['sec355stock'] && this.attMap['sec355stock'][0]) {
        this.sec355stock = this.attMap['sec355stock'][0] === '1';
      }
      if (this.attMap['sHolderName'] && this.attMap['sHolderName'][0]) {
        this.controllingShareholder = this.attMap['sHolderName'][0];
      }
      if (this.attMap['sHolderEin'] && this.attMap['sHolderEin'][0]) {
        this.identifyingNumber = this.attMap['sHolderEin'][0];
      }
      if (this.attMap['TransfereeName'] && this.attMap['TransfereeName'][0]) {
        this.name = this.attMap['TransfereeName'][0];
      }
      if (this.attMap['TransfereeId'] && this.attMap['TransfereeId'][0]) {
        this.id = this.attMap['TransfereeId'][0];
      }
      if (this.attMap['AddressLine1'] && this.attMap['AddressLine1'][0]) {
        this.address1 = this.attMap['AddressLine1'][0];
      }
      if (this.attMap['AddressLine2'] && this.attMap['AddressLine2'][0]) {
        this.address2 = this.attMap['AddressLine2'][0];
      }
      if (this.attMap['City'] && this.attMap['City'][0]) {
        this.city = this.attMap['City'][0];
      }
      if (this.attMap['ProvinceOrState'] && this.attMap['ProvinceOrState'][0]) {
        this.state = this.attMap['ProvinceOrState'][0];
      }
      if (this.attMap['PostalCode'] && this.attMap['PostalCode'][0]) {
        this.postal = this.attMap['PostalCode'][0];
      }
      if (this.attMap['TransfereeCountry'] && this.attMap['TransfereeCountry'][0]) {
        this.country2 = this.attMap['TransfereeCountry'][0];
      }
      if (this.attMap['ForeignLawCharacterization'] && this.attMap['ForeignLawCharacterization'][0]) {
        this.foreign = this.attMap['ForeignLawCharacterization'][0];
      }
      if (this.attMap['transferredlossamount'] && this.attMap['transferredlossamount'][0]) {
        this.transferredLoss = this.attMap['transferredlossamount'][0];
      }
      if (this.attMap['totalanticipatedincome'] && this.attMap['totalanticipatedincome'][0]) {
        this.regulationAmt = this.attMap['totalanticipatedincome'][0];
      }
      if (this.attMap['SupplementalInfo'] && this.attMap['SupplementalInfo'][0]) {
        this.suppInfo = this.attMap['SupplementalInfo'][0];
      }
      if (this.attMap['transferinterestbefore'] && this.attMap['transferinterestbefore'][0]) {
        this.before = this.attMap['transferinterestbefore'][0];
      }
      if (this.attMap['transferinterestafter'] && this.attMap['transferinterestafter'][0]) {
        this.after = this.attMap['transferinterestafter'][0];
      }
      if (this.attMap['NonrecognitionTransactionType'] && this.attMap['NonrecognitionTransactionType'][0]) {
        this.transaction = this.attMap['NonrecognitionTransactionType'][0];
      }
      if (this.attMap['amountofgainorloss367e'] && this.attMap['amountofgainorloss367e'][0]) {
        this.gainOrLoss = this.attMap['amountofgainorloss367e'][0];
      }

      if (this.attMap['TransferorEinMissingReason'] && this.attMap['TransferorEinMissingReason'][0]) {
        const updatedData = this.updateDropdownList(this.EINMissingReason, this.attMap['TransferorEinMissingReason'][0]);
        this.EINMissingReason = updatedData.dropdownData;
        this.transferorEinMissingReason = this.attMap['TransferorEinMissingReason'][0];
        this.selectedTransferorEINItem = this.EINMissingReason.find((i: any) => i.selected) || null;
      }
      if (this.attMap['ShareholderEinMissingReason'] && this.attMap['ShareholderEinMissingReason'][0]) {
        const updatedData = this.updateDropdownList(this.EINMissingReason1, this.attMap['ShareholderEinMissingReason'][0]);
        this.EINMissingReason1 = updatedData.dropdownData;
        this.selectedMissingReason1 = updatedData.index;
        this.selectedEINMissing1Item = this.EINMissingReason1.find((i: any) => i.selected) || null;
      }
      if (this.attMap['EinMissingReason1'] && this.attMap['EinMissingReason1'][0]) {
        const updatedData = this.updateDropdownList(this.EINMissingReason2, this.attMap['EinMissingReason1'][0]);
        this.EINMissingReason2 = updatedData.dropdownData;
        this.selectedMissingReason2 = this.attMap['EinMissingReason1'][0];
        this.selectedEINMissing2Item = this.EINMissingReason2.find((i: any) => i.selected) || null;
      }
      if (this.attMap['EinMissingReason'] && this.attMap['EinMissingReason'][0]) {
        const updatedData = this.updateDropdownList(this.EINMissingReason3, this.attMap['EinMissingReason'][0]);
        this.EINMissingReason3 = updatedData.dropdownData;
        this.selectedMissingReason3 = updatedData.index;
        this.selectedEINMissing3Item = this.EINMissingReason3.find((i: any) => i.selected) || null;
      }

      console.log(this.attMap);

      //Part III tabs
      const tabsLength = this.getMaxLengthOfArrays(this.attMap['TypeOfProperty'], this.attMap['DateOfTransfer']
        , this.attMap['DescOfPropTransferred'], this.attMap['FMVOnDateOfTransfer'], this.attMap['CostBasis'], this.attMap['usefulLife']
        , this.attMap['GainTransfer'], this.attMap['ArmsOnDateOfTransfer'], this.attMap['IncomeInclusionOfTransfer']);
      if (tabsLength > 0) {
        this.tabs = [];
        [...Array(tabsLength)].forEach((element: string, index: number) => {
          this.tabs.push({
            label: (index + 1) + '.' + ((this.sharedService.getFormStateByFormId(214)?.isChild)
            && (tabsLength != this.attMap['TypeOfProperty']?.length) ? this.getAttrValStr('DescOfPropTransferred', index) : this.getAttrValStr('TypeOfProperty', index)),
            labelIndex: index + 1,
            propertyType: ((this.sharedService.getFormStateByFormId(214)?.isChild) && tabsLength != this.attMap['TypeOfProperty']?.length)
              ? this.getAttrValStr('DescOfPropTransferred', index) : this.getAttrValStr('TypeOfProperty', index),
            date: this.getAttrValStr('DateOfTransfer', index),
            description: this.getAttrValStr('DescOfPropTransferred', index),
            fairMarketVal: this.parseNullableInt(this.getAttrValStr('FMVOnDateOfTransfer', index, 'number')),
            cost: this.parseNullableInt(this.getAttrValStr('CostBasis', index, 'number')),
            gain: this.parseNullableInt(this.getAttrValStr('GainTransfer', index, 'number')),
            useful: this.parseNullableInt(this.getAttrValStr('usefulLife', index, 'number')),
            armLength: this.parseNullableInt(this.getAttrValStr('ArmsOnDateOfTransfer', index, 'number')),
            income: this.parseNullableInt(this.getAttrValStr('IncomeInclusionOfTransfer', index, 'number')),
            propertyTypeOptions: this.initializePropertyTypeOptions(),
            dateObj: new Date(this.attMap['DateOfTransfer'][index] + 'T00:00:00'),
            selectedPropertyTypeItem: null
          });
          // select propertyType from dropdown list
          const propertyTypes: any[] = this.tabs[index].propertyTypeOptions;
          propertyTypes.forEach((item) => {
            item.selected = (this.sharedService.getFormStateByFormId(214)?.isChild) && (tabsLength != this.attMap['TypeOfProperty']?.length)
              ? (item.label === this.tabs[index].propertyType) : (item.value === this.tabs[index].propertyType);
            ((this.sharedService.getFormStateByFormId(214)?.isChild) && (tabsLength != this.attMap['TypeOfProperty']?.length) && item.selected)
            && (this.tabs[index].propertyType = item.value);
          });
          this.tabs[index].selectedPropertyTypeItem = this.tabs[index].propertyTypeOptions.find((i: any) => i.selected) || null;

        });

        this.selectTab(0);
        // console.log(this.tabs);
      }

      this.cdref.detectChanges();

      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.primaryleid);
              break;
            case 1:
              if (this.attMap['NameOfPartnership'] && this.attMap['NameOfPartnership'][0]) {
                this.sharedService.getDSTEntityInfo(this.attMap['NameOfPartnership'][0]).pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe((data: any) => {
                    this.leidComponents.toArray()[1].fillLEID(data[0].LEID);
                    setTimeout(() => {
                      if (this.attMap['PartnershipEinMissingReason'] && this.attMap['PartnershipEinMissingReason'][0]) {
                        const updatedData = this.updateDropdownList(this.EINMissingReason4, this.attMap['PartnershipEinMissingReason'][0]);
                        this.EINMissingReason4 = safeJsonInput<any>(JSON.stringify(updatedData.dropdownData), null, 'template-sec926-id214.parse1');
                        this.selectedMissingReasonPart = updatedData.index;
                        this.selectedEINMissing4Item = this.EINMissingReason4.find((i: any) => i.selected) || null;
                      }
                    }, 1000);
                  }, () => {

                  }, () => {

                  });
              }
              break;
            case 2:
              element.fillLEID(data.secondaryleid);
              break;
          }
        });
      }, 100);
    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      setTimeout(() => {
        this.leidComponents.toArray()[0].fillLEID(this.sharedService.leid);
      });
    }
  }

  private getAttrValStr(key: string, index: number, attrType: string = 'string'): string {
    if (this.attMap[key] === undefined || this.attMap[key].length === 0) {
      return ''; // Return empty string for both types - let the component handle default values
    }
    return this.attMap[key][index] || '';
  }

  private parseNullableInt(value: string): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const parsed = parseInt(value);
    return isNaN(parsed) ? null : parsed;
  }

  private getMaxLengthOfArrays(...arrays: any[]): number {
    return Math.max(...arrays.filter(ele => ele).map(item => item.length));
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferor, this.transferee, this.partnership])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferor),
        'secondaryEntityId': safeEntityId(this.transferee),
        'branchEntityId': '',
        'comments': '',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
      };
      const TypeOfProperty: string[] = [];
      const DateOfTransfer: string[] = [];
      const DescOfPropTransferred: string[] = [];
      const usefulLife: string[] = [];
      const ArmsOnDateOfTransfer: string[] = [];
      const CostOtherBasis: string[] = [];
      const IncomeInclusionOfTransfer: string[] = [];
      const FMVOnDateOfTransfer: string[] = [];
      const CostBasis: string[] = [];
      const GainTransfer: string[] = [];
      this.tabs.forEach((tab: S926PropertyTab) => {
        TypeOfProperty.push(toSaveString(tab.propertyType));
        DateOfTransfer.push(toSaveString(tab.date));
        DescOfPropTransferred.push(toSaveString(tab.description));
        usefulLife.push(toSaveString(tab.useful));
        ArmsOnDateOfTransfer.push(tab.armLength !== null && tab.armLength !== undefined ? stripAmountFormatting(toSaveString(tab.armLength)) : '');
        CostOtherBasis.push(tab.cost !== null && tab.cost !== undefined ? stripAmountFormatting(toSaveString(tab.cost)) : '');
        IncomeInclusionOfTransfer.push(tab.income !== null && tab.income !== undefined ? stripAmountFormatting(toSaveString(tab.income)) : '');
        FMVOnDateOfTransfer.push(tab.fairMarketVal !== null && tab.fairMarketVal !== undefined ? stripAmountFormatting(toSaveString(tab.fairMarketVal)) : '');
        CostBasis.push(tab.cost !== null && tab.cost !== undefined ? stripAmountFormatting(toSaveString(tab.cost)) : '');
        GainTransfer.push(tab.gain !== null && tab.gain !== undefined ? stripAmountFormatting(toSaveString(tab.gain)) : '');
      });

      const jsonObject = {
        'TransferorEinMissingReason': toSaveString(this.transferorEinMissingReason, ''),
        'transfereeForeignCorp': this.transfereeForeignCorp ? '1' : '0',
        'Choice1a': this.Choice1a != undefined ? this.Choice1a ? 'Yes' : 'No' : '',
        'Choice1b': this.Choice1a != undefined ? this.Choice1b ? 'Yes' : 'No' : '',
        'sHolderName': this.controllingShareholder,
        'sHolderEin': this.identifyingNumber,
        'EinOrSsn': this.EinOrSsn !== undefined ? this.EinOrSsn : '',
        'parentCorp': this.Choice1c !== undefined ? this.Choice1c && safeEntityField(this.transferor, 'BUSINESS') : '',
        'parentCorpEin': this.Choice1c !== undefined ? this.Choice1c && this.transferor ? this.transferor.EIN ? safeEntityField(this.transferor, 'EIN') : '' : 'APPLD FOR' : '',
        'ShareholderEinMissingReason': this.selectedMissingReason1 != -1 ? toSaveString(this.selectedMissingReason1) : '',
        'Choice1c': this.Choice1c != undefined ? this.Choice1c ? 'Yes' : 'No' : '',
        'Choice1d': this.Choice1d != undefined ? this.Choice1d ? 'Yes' : 'No' : '',
        'NameOfPartnershipLEID': safeEntityField(this.partnership, 'LEID'),
        'NameOfPartnership': safeEntityField(this.partnership, 'ENTITYID'),
        'BusinessOfPartnership': safeEntityField(this.partnership, 'BUSINESSID'),
        'EinOfPartnerShip': safeEntityField(this.partnership, 'EIN'),
        'PartnershipEinMissingReason':  this.selectedMissingReasonPart !== -1 ? (toSaveString(this.selectedMissingReasonPart, '')): '',
        'Choice2b': this.Choice2b != undefined ? this.Choice2b ? 'Yes' : 'No' : '',
        'Choice2c': this.Choice2c != undefined ? this.Choice2c ? 'Yes' : 'No' : '',
        'Choice2d': this.Choice2d != undefined ? this.Choice2d ? 'Yes' : 'No' : '',
        'IsForeignCorpInGold': this.IsForeignCorpInGold != undefined ? this.IsForeignCorpInGold ? 'Yes' : 'No' : '',
        'EinMissingReason': this.selectedMissingReason3 != -1 ? toSaveString(this.selectedMissingReason3): '',
        'TransfereeLEID': safeEntityField(this.transferee, 'LEID'),
        'Business1': safeEntityField(this.transferee, 'BUSINESSID'),
        'EinMissingReason1': toSaveString(this.selectedMissingReason2, ''),
        'TransfereeName': this.name,
        'TransfereeId': this.id,
        'AddressLine1': this.address1,
        'AddressLine2': this.address2,
        'City': this.city,
        'ProvinceOrState': this.state,
        'PostalCode': this.postal,
        'Country': this.country,
        'TransfereeCountry': this.country2,
        'ForeignLawCharacterization': this.foreign,
        'IsTransfereeForeignCorpCtrld': this.IsTransfereeForeignCorpCtrld ? 'Yes' : 'No',
        'TypeOfProperty': TypeOfProperty,
        'DateOfTransfer': DateOfTransfer,
        'DescOfPropTransferred': DescOfPropTransferred,
        'usefulLife': usefulLife,
        'ArmsOnDateOfTransfer': ArmsOnDateOfTransfer,
        'CostOtherBasis': CostOtherBasis,
        'IncomeInclusionOfTransfer': IncomeInclusionOfTransfer,
        'FMVOnDateOfTransfer': FMVOnDateOfTransfer,
        'CostBasis': CostBasis,
        'GainTransfer': GainTransfer,
        'cashonlytransfered': this.cashonlytransfered != undefined ? this.cashonlytransfered ? '1' : '0' : '',
        'transferunder367a': this.transferunder367a != undefined ? this.transferunder367a ? '1' : '0' : '',
        'foreignassets': this.foreignassets != undefined ? this.foreignassets ? '1' : '0' : '',
        'domesticcorptransfer': this.domesticcorptransfer != undefined ? this.domesticcorptransfer ? '1' : '0' : '',
        'transfereeshareholder': this.transfereeshareholder != undefined ? this.transfereeshareholder ? '1' : '0' : '',
        'transferredlossamount': this.transferredLoss !== null && this.transferredLoss !== undefined ? toSaveString(this.transferredLoss) : '',
        'intangiblepropsec936h': this.intangiblepropsec936h != undefined ? this.intangiblepropsec936h ? '1' : '0' : '',
        'intangibleusefullife': this.intangibleusefullife != undefined ? this.intangibleusefullife ? '1' : '0' : '',
        'indefiniteusefullife': this.indefiniteusefullife != undefined ? this.indefiniteusefullife ? '1' : '0' : '',
        'intangiblepropinclusion': this.intangiblepropinclusion != undefined ? this.intangiblepropinclusion ? '1' : '0' : '',
        'totalanticipatedincome': this.regulationAmt !== null && this.regulationAmt !== undefined ? toSaveString(this.regulationAmt) : '',
        'anticipatedtransfer': this.anticipatedtransfer !== undefined ? this.anticipatedtransfer ? '1' : '0' : '',
        'SupplementalInfo': this.suppInfo,
        'transferinterestbefore': this.before !== null && this.before !== undefined ? toSaveString(this.before) : '',
        'transferinterestafter': this.after !== null && this.after !== undefined ? toSaveString(this.after) : '',
        'NonrecognitionTransactionType': this.transaction !== null && this.transaction !== undefined ? toSaveString(this.transaction) : '',
        'gainunder904f3': this.gainunder904f3 != undefined ? this.gainunder904f3 ? '1' : '0' : '',
        'gainunder904f5': this.gainunder904f5 != undefined ? this.gainunder904f5 ? '1' : '0' : '',
        'recapunder1503d': this.recapunder1503d != undefined ? this.recapunder1503d ? '1' : '0' : '',
        'exchangeunder987': this.exchangeunder987 != undefined ? this.exchangeunder987 ? '1' : '0' : '',
        'forcorptransferee': this.forcorptransferee != undefined ? this.forcorptransferee ? '1' : '0' : '',
        'domesticcorpsec367e': this.domesticcorpsec367e != undefined ? this.domesticcorpsec367e ? '1' : '0' : '',
        'amountofgainorloss367e': this.gainOrLoss !== null && this.gainOrLoss !== undefined ? toSaveString(this.gainOrLoss) : '',
        'propusedinustrade': this.propusedinustrade != undefined ? this.propusedinustrade ? '1' : '0' : '',
        'sec355stock': this.sec355stock != undefined ? this.sec355stock ? '1' : '0' : ''
      };
      stripAmountFields(jsonObject, [...SEC926_ARRAY_AMOUNT_KEYS, ...SEC926_SCALAR_AMOUNT_KEYS, 'amountofgainorloss367e']);
      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.sharedService.setSavedStatementId(data.statementId);
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
      }).add(() => {
        this.startLoader = false;
      });
    }

  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  updateDropdownList(currentOptions: any[], element: string, useId: boolean = false) {
    const updateList: any[] = [];
    let selectedIndex: string | number = -1;
    const opts = Array.isArray(currentOptions) ? currentOptions : [];
    opts.forEach((el: any, index: number) => {
      const displayLabel = el.label ?? el.text;
      const elementValue = useId ? el.value : displayLabel;
      if (element === elementValue || String(element) === String(elementValue)) {
        updateList.push({
          id: el.id,
          value: el.value,
          label: displayLabel,
          index,
          selected: true,
        });
        selectedIndex = el.value;
      } else {
        updateList.push({
          id: el.id,
          value: el.value,
          label: displayLabel,
          index: el.value,
        });
      }
    });
    return {dropdownData: updateList, index: selectedIndex};
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    const splits: string[] = consolGroup.DCNNAME.split('- (');
    this.dcnName = splits[0].trim();
    //this.dcnIDNum = splits[1].slice(0, -1).trim();
    this.dcnIDNum = splits[1].split(')')[0].trim();
    this.dcnId = consolGroup.DCNID;
  }

  check1(val: boolean) {
    this.transfereeForeignCorp = val;
  }

  check2a(val: boolean) {
    this.Choice1a = val;
  }

  check2b(val: boolean) {
    this.Choice1b = val;
  }

  check2c(val: boolean) {
    this.Choice1c = val;
  }

  check2d(val: boolean) {
    this.Choice1d = val;
  }

  checkEINorSSN(val: string) {
    this.EinOrSsn = val;
  }

  check3b(val: boolean) {
    this.Choice2b = val;
  }

  check3c(val: boolean) {
    this.Choice2c = val;
  }

  check3d(val: boolean) {
    this.Choice2d = val;
  }

  check9(val: boolean) {
    this.IsTransfereeForeignCorpCtrld = val;
  }

  check10(val: boolean) {
    this.cashonlytransfered = val;
  }

  check11(val: boolean) {
    this.transferunder367a = val;
  }

  check12a(val: boolean) {
    this.foreignassets = val;
  }

  check12b(val: boolean) {
    this.domesticcorptransfer = val;
  }

  check12c(val: boolean) {
    this.transfereeshareholder = val;
  }

  check13(val: boolean) {
    this.intangiblepropsec936h = val;
    this.check14a(false);
    this.check14b(false);
    this.check14c(false);
    this.check15(false);
  }

  check14a(val: boolean) {
    this.intangibleusefullife = val;
  }

  check14b(val: boolean) {
    this.indefiniteusefullife = val;
  }

  check14c(val: boolean) {
    this.intangiblepropinclusion = val;
  }

  check15(val: boolean) {
    this.anticipatedtransfer = val;
  }

  check18a(val: boolean) {
    this.gainunder904f3 = val;
  }

  check18b(val: boolean) {
    this.gainunder904f5 = val;
  }

  check18c(val: boolean) {
    this.recapunder1503d = val;
  }

  check18d(val: boolean) {
    this.exchangeunder987 = val;
  }

  check19(val: boolean) {
    this.forcorptransferee = val;
  }

  check20a(val: boolean) {
    this.domesticcorpsec367e = val;
  }

  check20c(val: boolean) {
    this.propusedinustrade = val;
  }

  check21(val: boolean) {
    this.sec355stock = val;
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferor = selectedTransferor;
    this.headerComponent.loadConsolGroups(selectedTransferor!.LEID,this.dcnId);
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.partnership!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;
    this.updateEntitiesName();
  }

  onTransfereeChanged(selectedTransferee: DSTEntityDetails | null): void {
    this.transferee = selectedTransferee;
    if (this.transferee) {
      this.stateValue = this.transferee.STATE;
      const selectedState = this.StateOptions.find((s: any) => s.value === this.transferee?.STATE);
      selectedState && (this.stateValue = selectedState.label);
    }

    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee!, this.transferor!, this.partnership!]);
    this.showDREMsg = !!this.DREMsg;
    this.updateEntitiesName();
  }

  onPartnershipChanged(selectedPartnership: DSTEntityDetails | null): void {
    this.partnership = selectedPartnership;
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.partnership!, this.transferor!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;
    this.selectedMissingReasonPart = -1;
    this.selectedEINMissing4Item = null;
    this.EINMissingReason4 = [
      { value: '', label: '** Please select the missing reason **' },
      {
        id: 1,
        value: 'APPLD FOR',
        label: 'APPLD FOR'
      },
      {
        id: 2,
        value: 'FOREIGNUS',
        label: 'FOREIGNUS'
      },
    ];
    this.updateEntitiesName();
  }

  private updateEntitiesName(): void {
    if ((this.transferor?.LEID || this.transferee?.LEID || this.partnership?.LEID) && this.tabs[0].date) {
      const leids: string = this.sharedService.concatLEIDs([this.transferor!, this.transferee!, this.partnership!]);
      if (!leids) {
        return;
      }
      this.startLoader = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        leids,
        this.tabs[0].date,
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response.length > 0) {
          for (let i = 0; i < leids.split(',').length; i++) {
            if (response[i] && response[i].LEID) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.transferor!, this.transferee!, this.partnership!], response[i].TAXTYPECODE);
            } else {
              console.warn(`Response[${i}] is undefined or missing LEID:`, response[i]);
            }
          }
        } else {
          console.warn('Response is empty or undefined:', response);
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }
  }

  checkTransferee(event: Object) {
    this.showTransferee = true;
    this.showTransfereeManual = false;
    this.IsForeignCorpInGold = true;
    this.name = '';
    this.id = '';
    this.selectedMissingReason2 = '';
    this.sharedService.resetAppkitDropdown(this.EINMissingReason2);
    this.selectedEINMissing2Item = null;
    this.address1 = '';
    this.address2 = '';
    this.city = '';
    this.state = '';
    this.country = '';
    this.sharedService.resetAppkitDropdown(this.countryDropdown1);
    this.selectedCountry1Item = null;
    this.postal = '';
    this.country2 = '';
    this.sharedService.resetAppkitDropdown(this.countryDropdown2);
    this.selectedCountry2Item = null;
    this.foreign = '';
  }

  checkTransfereeManual(event: Object) {
    this.showTransfereeManual = true;
    this.showTransferee = false;
    this.IsForeignCorpInGold = false;
    this.transferee = null;
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.transferee!, this.partnership!]);
    this.showDREMsg = !!this.DREMsg;
  }

  existenceCheck(hide: boolean) {
    this.showControllingShareHolders = !hide;
    if (!this.showControllingShareHolders) {
      this.controllingShareholder = '';
      this.identifyingNumber = '';
      this.EinOrSsn = '';
      this.selectedMissingReason1 = -1;
      this.sharedService.resetAppkitDropdown(this.EINMissingReason1);
      this.selectedEINMissing1Item = null;
    }
    this.check2b(hide);
  }

  parentCoorporationCheck(event: Object, hide: boolean) {
    this.check2c(hide);
  }

  onFormOptionChanged(selectedOptionID: Event): void {
    this.selectedOptionID = selectedOptionID;
  }

  checkSection(event: Object) {
    this.hideSections = !this.hideSections;
    this.check10(this.hideSections);
  }

  checkForeign(val: boolean) {
    this.isForeignCorporation = val;
    if (!val) {
      this.transferredLoss = '';
    }
    this.check12a(this.isForeignCorporation);
  }

  checkForeign2(val: boolean) {
    this.isForeignCorporation2 = val;
    this.check12b(this.isForeignCorporation2);
    if (!val) {
      this.transferredLoss = '';
    }
  }

  checkForeign3(val: boolean) {
    this.isForeignCorporation3 = val;
    this.check12c(this.isForeignCorporation3);
    if (!val) {
      this.transferredLoss = '';
    }
  }

  checkDomesticCorporation(event: Object, option: string) {
    this.showDomesticCorporation = (option === 'Yes') ? true : false;
    this.check20a(this.showDomesticCorporation);
  }

  addTab() {
    const lastIndex: number = this.tabs[this.tabs.length - 1].labelIndex;
    this.tabs.push(
      {
        label: (lastIndex + 1).toString(),
        labelIndex: lastIndex + 1,
        propertyType: '',
        date: '',
        description: '',
        fairMarketVal: 0,
        cost: 0,
        gain: 0,
        useful: 0,
        armLength: 0,
        income: 0,
        propertyTypeOptions: this.initializePropertyTypeOptions(),
        dateObj: null,
        selectedPropertyTypeItem: null
      }
    );
    this.selected.setValue(this.tabs.length - 1);
  }

  removeTab(index: number) {
    this.tabs.splice(index, 1);
  }

  propertyTypeChange(event: AppkitDropDownEventType | any, index: number) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.tabs[index].selectedPropertyTypeItem = change;
    this.tabs[index].label = this.tabs[index].labelIndex + '.' + change?.label;
    this.tabs[index].propertyType = change?.value;
  }

  private initializePropertyTypeOptions(): any[] {
    return [
      {
        value: 'cash',
        label: 'Cash',
        index: 0,
      },
      {
        value: 'stockssecurities',
        label: 'Stocks and securities',
        index: 1,
      },
      {
        value: 'inventory',
        label: 'Inventory',
        index: 2,
      },
      {
        value: 'otherProp926',
        label: 'Other Property (not listed under another category)',
        index: 3,
      },
      {
        value: 'lossProp',
        label: 'Property with built-in loss',
        index: 4,
      },
      {
        value: 'propdescribed367d4',
        label: 'Property described in sec.367(d)(4)',
        index: 5,
      }
    ];
  }

  selectTab(event: number) {
    this.selected.setValue(event);
  }

  onValueChange(event: any, index: number, field: string) {
    console.log(event.value ? event.value : event);
    switch (field) {
      case 'property':
        this.tabs[index].description = event;
        break;
      case 'fair':
        this.tabs[index].fairMarketVal = event.value;
        break;
      case 'cost':
        this.tabs[index].cost = event.value;
        break;
      case 'gain':
        this.tabs[index].gain = event.value;
        break;
      case 'useful':
        this.tabs[index].useful = event.value;
        break;
      case 'armsLength':
        this.tabs[index].armLength = event.value;
        break;
      case 'income':
        this.tabs[index].income = event.value;
        break;
      default:
        break;
    }
  }

  missingReason1(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedEINMissing1Item = change;
    this.selectedMissingReason1 = change?.value;
  }

  onTransferorEINMissingChange(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedTransferorEINItem = change;
    this.transferorEinMissingReason = change?.value;
  }

  missingReason2(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedEINMissing2Item = change;
    this.selectedMissingReason2 = change?.value;
  }

  missingReason3(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedEINMissing3Item = change;
    this.selectedMissingReason3 = change?.value;
  }

  missingReasonPart(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedEINMissing4Item = change;
    this.selectedMissingReasonPart = change?.value;
  }

  selectCountry1(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCountry1Item = change;
    this.country = change?.value;
  }

  selectCountry2(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCountry2Item = change;
    this.country2 = change?.value;
  }

  identifyingNumberCheck2(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedMissingReason2 = change?.value;
  }

  dateChange(event: { startDate: any, endDate: any }, index: number) {
    console.log(event, index);
    this.tabs[index].date = event.startDate.format('YYYY-MM-DD');
    if (index === 0) {
      this.updateEntitiesName();
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  /**
   * Clear date picker
   * @param index - Date picker index
   */
  clearDate(index: number): void {
    if (this.tabs && this.tabs[index]) {
      this.tabs[index].date = '';
    }
    
    // 🚀 CRITICAL: Force change detection and ensure date picker updates
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();
    
    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      index = 0; // for tab wise it will show only active which has only one date picker
      // For template-sec926-id214, we need to find the date picker by index since it's in a loop
      const datePickerElements = document.querySelectorAll('app-date-picker-with-clear');
      if (datePickerElements && datePickerElements[index]) {
        const inputElement = datePickerElements[index].querySelector('input');
        if (inputElement && inputElement.value) {
          // Clear the input value and trigger change event
          inputElement.value = '';
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
          inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  isFormValid(placeholder: boolean): boolean {
    // Part I
    if (!this.transferor) {
      this.dstSharedService.showAlert('error', 'Please specify a Transferor');
      return false;
    }
    // skip further validation if created as a placeholder
    if (placeholder) {
      return true;
    }
    if (this.dcnId === undefined) {
      this.dstSharedService.showAlert('error', 'Please select a consolidate group from the form header');
      return false;
    }
    if (this.transfereeForeignCorp === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Part 1 Line 1');
      return false;
    }
    if (this.Choice1a === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Part 1 Line 2a');
      return false;
    }
    if (this.Choice1b === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Part 1 Line 2b');
      return false;
    } else {
      if (!this.Choice1b) {
        if (!this.controllingShareholder) {
          this.dstSharedService.showAlert('error', 'Please specify a Controlling shareholder under line 2b');
          return false;
        }
        if (!this.EinOrSsn && this.identifyingNumber) {
          this.dstSharedService.showAlert('error', 'Please select EIN or SSN under line 2b');
          return false;
        }
        if (!this.identifyingNumber && (this.selectedMissingReason1 < 0 || toSaveString(this.selectedMissingReason1) === '')) {
          this.dstSharedService.showAlert('error', 'Please select an EIN missing reason under line 2b');
          return false;
        }
      }
    }
    if (this.Choice1c === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Part 1 Line 2c');
      return false;
    }
    if (this.partnership && !this.partnership.EIN && (this.selectedMissingReasonPart < 0 || toSaveString(this.selectedMissingReasonPart) == '')) {
      this.dstSharedService.showAlert('error', 'Please select an EIN missing reason under line 3a');
      return false;
    }
    // Part II
    if (this.IsForeignCorpInGold === undefined) {
      this.dstSharedService.showAlert('error', 'Please specify if the foreign corporation is in Gold');
      return false;
    } else {
      if (this.IsForeignCorpInGold) {
        if (!this.transferee) {
          this.dstSharedService.showAlert('error', 'Please specify the Transferee');
          return false;
        }
        if ((!this.transferee.EIN || this.transferee.EIN === 'N/A') && (this.selectedMissingReason3 === -1 || this.selectedMissingReason3.toString() === '')) {
          this.dstSharedService.showAlert('error', 'Please select EIN Missing Reason for the transferee');
          return false;
        }
      } else {
        if (this.name === '') {
          this.dstSharedService.showAlert('error', 'Please specify the transferee name');
          return false;
        }
        if ((this.id === '' || this.id === 'N/A') && this.selectedMissingReason2 === '') {
          this.dstSharedService.showAlert('error', 'Please select EIN Missing Reason for the transferee');
          return false;
        }
        if(this.id !== '' && !this.isValidNumber(this.id)){
          this.dstSharedService.showAlert('error', 'Please enter Valid EIN');
          return false;
        }
        if(this.id !== '' && this.id.length !== 9){
          this.dstSharedService.showAlert('error', 'Please enter 9 digits EIN Number');
          return false;
        }
        if (this.address1 === '') {
          this.dstSharedService.showAlert('error', 'Please specify the address of the transferee');
          return false;
        }
        if (this.country === '') {
          this.dstSharedService.showAlert('error', 'Please specify the country of the transferee');
          return false;
        }
        if (this.country2 === '') {
          this.dstSharedService.showAlert('error', 'Please specify the country of incorportation for the transferee');
          return false;
        }
        if (this.foreign === '') {
          this.dstSharedService.showAlert('error', 'Please mention foreign law of characterization');
          return false;
        }
      }
    }
    if (this.IsTransfereeForeignCorpCtrld === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Line 9');
      return false;
    }
    // Part III
    // tabs
    let cashOnly: boolean = true;
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].propertyType === '') {
        this.dstSharedService.showAlert('error', `Tab-${this.tabs[i].labelIndex}: Please specify the Type of Property`);
        return false;
      } else {
        if (cashOnly && this.tabs[i].propertyType !== 'cash') {
          cashOnly = false;
        }
      }
      if (this.tabs[i].date === '') {
        this.dstSharedService.showAlert('error', `Tab-${this.tabs[i].labelIndex}: Please specify Date of Transfer`);
        return false;
      }
      if (this.tabs[i].propertyType !== 'cash' && !this.tabs[i].description) {
        this.dstSharedService.showAlert('error', `Tab-${this.tabs[i].labelIndex}: Please specify the Decription of the Property`);
        return false;
      }
    }
    if (cashOnly && !this.hideSections) {
      this.dstSharedService.showAlert('error', 'If Cash is the only property transferred, select Line 10 to Yes');
      return false;
    }
    if (!cashOnly && this.hideSections) {
      this.dstSharedService.showAlert('error', 'If Cash is not the only property transferred, select Line 10 to No');
      return false;
    }
    // 12a-d and 14
    if (!this.hideSections) {
      if (this.foreignassets === undefined) {
        this.dstSharedService.showAlert('error', 'Please complete Line 12a');
        return false;
      }
      if (this.isForeignCorporation) {
        if (this.domesticcorptransfer === undefined) {
          this.dstSharedService.showAlert('error', 'Please complete Line 12b');
          return false;
        }
      }
      if (this.isForeignCorporation2) {
        if (this.transfereeshareholder === undefined) {
          this.dstSharedService.showAlert('error', 'Please complete Line 12c');
          return false;
        }
      }
      if (this.isForeignCorporation3) {
        if (this.transferredLoss === '') {
          this.dstSharedService.showAlert('error', 'Please complete Line 12d');
          return false;
        }
      }
      if (this.intangiblepropsec936h && this.intangiblepropinclusion && this.regulationAmt === '') {
        this.dstSharedService.showAlert('error', 'Please complete Line 14d');
        return false;
      }
    }
    // Part IV
    if (this.transaction === '') {
      this.dstSharedService.showAlert('error', 'Please complete Line 17');
      return false;
    }
    if (this.showDomesticCorporation) {
      if (this.gainOrLoss === '') {
        this.dstSharedService.showAlert('error', 'Please complete Line 20b');
        return false;
      }
      if (this.propusedinustrade === undefined) {
        this.dstSharedService.showAlert('error', 'Please complete Line 20c');
        return false;
      }
    }
    if (this.sec355stock === undefined) {
      this.dstSharedService.showAlert('error', 'Please complete Line 21');
      return false;
    }

    return true;
  }
  isValidNumber(input: string) {
    const regex = /^\d+$/;
    input = input+'';
    if(regex.test(input)){
      return true;
    }
    else return false;
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.label || item?.text || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }

}

interface S926PropertyTab {
  label: string;
  labelIndex: number;
  propertyType: string;
  date: string;
  description: string;
  fairMarketVal: number | null;
  cost: number | null;
  gain: number | null;
  useful: number | null;
  armLength: number | null;
  income: number | null;
  propertyTypeOptions: any;
  dateObj: Date | null;
  selectedPropertyTypeItem: any;
}
